var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n        Name: "+_vm._s(_vm.item.name)),_c('br'),_vm._v("\n        URL: "+_vm._s(_vm.item.path)+"\n        "),_c('routes-list-items',{attrs:{"children":_vm.item.children}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-210af382","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Debug/Routes/RoutesList.vue
// module id = 654
// module chunks = 52